import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEventCategoryState }  from 'Redux/Slices/EventCategory/EventCategorySlice';
import { EventCategory }        from 'Domain/Models';
import { PayloadActionList }    from 'Utils';
import { removeActionTypes }    from 'Utils/ReducerUtility';


export const findEventCategoriesRequest = (state: Draft<IEventCategoryState>, { type }: PayloadActionList) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findEventCategoriesSuccess = (state: Draft<IEventCategoryState>, { type, payload }: PayloadAction<{
  eventCategories: Record<string, EventCategory>,
  maxCount: number,
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = payload.eventCategories;
  state.maxCount = payload.maxCount || state.maxCount;

};

export const findEventCategoriesFailure = (state: Draft<IEventCategoryState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
